import { createFileRoute } from '@tanstack/react-router'

import { AuthConfirmationPage } from '@/features/auth/pages'
import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'

export const Route = createFileRoute('/_event/auth/confirmation')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  component: TenantAuthConfirmationRoute
})

function TenantAuthConfirmationRoute() {
  const tenant = useTenantOptional()

  return (
    <AuthConfirmationPage
      digitalProductId={tenant?.digitalProductId ?? undefined}
    />
  )
}
